import type { ChangeEvent } from "react";

type AdminBranchedRadioQuestionProps = {
	question: string;

	note: string;

	questions: AdminObservationQuestion[];

	options?: AdminObservationAnswer[];

	onGoToChange: (value: string, answerId: number | null) => void;
};

const AdminBranchedRadioQuestion = ({
	question,
	note,
	questions,
	options,
	onGoToChange
}: AdminBranchedRadioQuestionProps) => {
	const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
		const answerId = e.target.dataset.answerId;
		if (!answerId) return;

		onGoToChange(e.target.value, parseInt(answerId));
	};

	return (
		<div className="w-full pt-5 pr-6 pb-8 pl-6 rounded-lg bg-muted flex flex-col gap-6">
			<p className="text-base font-medium text-foreground">Radio button</p>

			<div className="flex flex-col gap-4">
				<p className="text-xl font-medium">{question}</p>
				<p className="text-base font-normal">{note}</p>
			</div>

			<div className="flex flex-col gap-6">
				{options?.map((option) => (
					<div className="flex w-full items-end gap-2" key={option.id}>
						<div className="flex rounded bg-border h-10 flex-[0.5] px-4 items-center">
							{option.name}
						</div>

						<div className="flex-[0.5]">
							<div className="flex justify-between items-end mb-2">
								<label className="text-base font-medium">Go to</label>
								<span className="text-xs font-normal">Required</span>
							</div>

							<select
								className="w-full h-10 px-3 bg-white border border-border rounded"
								value={option.go_to ?? undefined}
								onChange={handleChange}
								data-answer-id={option.id}
							>
								<option value="NEXT">Next</option>
								<option value="END_OF_FORM">End of the form</option>

								<optgroup label="Questions in the form">
									{questions.map((question) => (
										<option key={question.id} value={question.id ?? undefined}>
											&ldquo;{question.question}&rdquo;
										</option>
									))}
								</optgroup>
							</select>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default AdminBranchedRadioQuestion;
